import { Button, Col } from "reactstrap";
import {
  THANK_YOU_CONTENT_HEADING,
  THANK_YOU_CONTENT_L1,
  THANK_YOU_CONTENT_L2,
  THANK_YOU_CONTENT_L3,
  THANK_YOU_TITLE,
} from "./ThankYou.const";
import { brand } from "services/envService";
import { redirectTo } from "util/redirect";
import {
  BOUNCE_BACK_LOAN_LINKS,
  EXIT_BUTTON_TEXT,
} from "components/AppendixScreen/HardStops.const";
import { CreateEnhancer } from "util/enhancer";
import { Heading, HeadingTag } from "components/common/Heading";
import {
  Notification,
  Status,
} from "components/common/Notification/Notification";

const BRAND = brand();
const onButtonClick = () => redirectTo(BOUNCE_BACK_LOAN_LINKS[BRAND]);

const ESIGN_EMAILS: Record<string, string> = {
  nwb: "service-esign-nw@natwest.com",
  rbs: "service-rbs-esign@rbs.co.uk",
  ubn: "service-esign-ub@ulsterbank.com",
};
export const ESIGN_EMAIL = ESIGN_EMAILS[BRAND];

type ThankYouProps = {};
const ThankYou = (props: ThankYouProps) => (
  <>
    <Col className="narrow-container">
      <div className="content-wrapper thankyou-screen">
        <Notification title={""} status={Status.SUCCESS}>
          <p>{THANK_YOU_TITLE}</p>
        </Notification>
        <div className="thankyou-content">
          <Heading
            tag={HeadingTag.h1}
            size={1}
            className="zb-heading1 screen-header"
            title={THANK_YOU_CONTENT_HEADING}
          />
          <ol className="thankyou-list">
            <li>
              <span>{THANK_YOU_CONTENT_L1}</span>
            </li>
            <li>
              <span>
                {THANK_YOU_CONTENT_L2}
                <span className="email-link">{ESIGN_EMAIL}.</span>
              </span>
            </li>
            <li>
              <span>{THANK_YOU_CONTENT_L3}</span>
            </li>
          </ol>
          <p>*unless advised otherwise in earlier screens</p>
          <Button size="lg" color="primary" onClick={onButtonClick}>
            {EXIT_BUTTON_TEXT}
          </Button>
        </div>
      </div>
    </Col>
  </>
);
export const EnhancedThankYou = CreateEnhancer<
  ThankYouProps,
  keyof ThankYouProps
>(() => false)(ThankYou);

export { EnhancedThankYou as ThankYou };
